import React, { useContext } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { CalendarDays, Clock, FileText, TreePalm, User } from 'lucide-react';
import { AuthContext } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import logoMark from '../../assets/hardwall-logo.webp';
import './portal.css';

// The guard portal: the only screens an employee account sees. Built for
// the phone first: a slim top bar, one page at a time, and the tab bar at
// the bottom within thumb reach. No management menu exists here.
const TABS = [
  { to: 'shifts', label: 'Shifts', icon: CalendarDays },
  { to: 'attendance', label: 'Attendance', icon: Clock },
  { to: 'payslips', label: 'Payslips', icon: FileText },
  { to: 'leave', label: 'Leave', icon: TreePalm },
  { to: 'me', label: 'Me', icon: User },
];

const PortalApp = () => {
  const { user } = useContext(AuthContext);
  const { t } = useLanguage();

  return (
    <div className="portal-app">
      <header className="pt-top">
        <img className="pt-top__logo" src={logoMark} alt="" width="32" height="32" />
        <span className="pt-top__brand">Hardwall</span>
        <span className="pt-top__who">{user && user.first_name}</span>
      </header>

      <main className="pt-main">
        <Outlet />
      </main>

      <nav className="pt-tabs" aria-label={t('Guard portal')}>
        {TABS.map((tab) => (
          <NavLink key={tab.to} to={tab.to} className={({ isActive }) => `pt-tab${isActive ? ' is-active' : ''}`}>
            <tab.icon aria-hidden="true" />
            <span>{t(tab.label)}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default PortalApp;
